import React, { useState, useEffect } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import Api from '../component/Api';
import Select from 'react-select';
import logo from '../Assets/img/logo.png';
import { error } from 'jquery';

const Viewresult = () => {

  const [loading, setLoading] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [gradeab, setGradeAb] = useState(false);
  const [gradePoints, setGradePoints] = useState([]);
  const navigate = useNavigate();
  const { http } = Api();


  // State for form data and CAPTCHA
  const [formData, setFormData] = useState({ examId: "", prn: "", captchaInput: "", captcha_id: "" });
  const [captchaImage, setCaptchaImage] = useState('');
  const [errorMessage, setErrorMessage] = useState("");
  const [getexamData, setExamData] = useState([]);
  const [studentData, setStudentData] = useState([]);
  const [isMalpractice, setMalpractice] = useState(false);


  // Handle form changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // Handle form submission
  const handleSubmit = async (e) => {

    e.preventDefault();

    try {
      setLoading(true);
      const response = await http.get(`Result/PublicResultView`, {
        params: {
          examid: formData.examId,
          prn: formData.prn,
          captcha_in: formData.captchaInput,
          captcha_id: formData.captcha_id
        },
      });


      if (response.data.status_code === "ERR5") {
        toast.error("No Data Found");
        setTableData([]);
      }
      else {


        setStudentData(response.data.studentDetails);
        setGradeAb(response.data.gradeDetails);
        setGradePoints(response.data.gradeDetails.concatenated_result);
        const apiData = Array.isArray(response.data.courseDetails)
          ? response.data.courseDetails
          : [];
        console.log({ apiData })

        const hasMalpractice = apiData.filter(
          (item) => (item.student_status && item.student_status.toLowerCase() === "malpractise")
        );
        console.log({ hasMalpractice })
        setMalpractice(hasMalpractice.length > 0);

        const mappedData = apiData.map((item) => ({
          category: item.paper_identifier || "-",
          course: item.course_name || "-",
          coursecd: item.course_code || "-",
          credits: item.theory_credit || "-",
          totalcredits: item.total_credit || "-",
          theory: {
            cca: (item.theory_pract === "T" || item.theory_pract === "B") ?
              (item.normalised_TI || "-") : "-",
            ccaMax: (item.theory_pract === "T" || item.theory_pract === "B") ?
              (item.normalised_TI_MAX || "-") : "-",
            ese: (item.theory_pract === "T" || item.theory_pract === "B") ?
              (item.normalised_TE || "-") : "-",
            eseMax: (item.theory_pract === "T" || item.theory_pract === "B") ?
              (item.normalised_TE_MAX || "-") : "-",
            total: (item.theory_pract === "T" || item.theory_pract === "B") ?
              (item.T_Total || "-") : "-",
            max: (item.theory_pract === "T" || item.theory_pract === "B") ?
              (item.normalised_T_Max || "-") : "-",
            theory_result: (item.theory_pract === "T" || item.theory_pract === "B") ?
              (item.theory_result || "-") : "-",
          },
          practical: {
            cca: (item.theory_pract === "P" || item.theory_pract === "B") ?
              (item.normalised_PI || "-") : "-",
            ccaMax: (item.theory_pract === "P" || item.theory_pract === "B") ?
              (item.normalised_PI_MAX || "-") : "-",
            ese: (item.theory_pract === "P" || item.theory_pract === "B") ?
              (item.normalised_PE || "-") : "-",
            eseMax: (item.theory_pract === "P" || item.theory_pract === "B") ?
              (item.normalised_PE_MAX || "-") : "-",
            total: (item.theory_pract === "P" || item.theory_pract === "B") ?
              (item.P_Total || "-") : "-",
            max: (item.theory_pract === "P" || item.theory_pract === "B") ?
              (item.normalised_P_Max || "-") : "-",
            practical_result: (item.theory_pract === "P" || item.theory_pract === "B") ?
              (item.practical_result || "-") : "-",
          },
          totalSecured: item.Total_Mark || "-",
          maxMarks: item.Total_Mark_Max || "-",
          grade: item.grade || "-",
          gradePoints: item.GP || "-",
          acquiredCredits: item.acquired_credit || "-",
          creditPoint: item.credit_point || "-",
          overallResult: item.result || "-",
        }));

        setTimeout(() => {
          setTableData(mappedData);
          setLoading(false);
          toast.success("Data fetched successfully");

        }, 1000);
      }



    } catch (error) {
      setTableData([]);
      setLoading(false);
      fetchCaptcha();


      const status = error.response?.data?.http_status;
      const message = error.response?.data?.message || "An error occurred";

      if (status === 500 || error.response?.data?.status_code === "ERR5") {
        toast.error(message);
      } else if (status === 403 && error.response?.data?.status_code === "ERR37") {
        toast.error("Invalid Token");
        setTimeout(() => navigate("/college/"), 5000);
      } else {
        toast.error(message);
      }
    }
  };



  useEffect(() => {
    const fetchExamData = async () => {
      try {
        const response = await http.get(`getActiveExam`);

        setExamData(response.data.activeexam);
      }
      catch (error) {
        if (error.response.data.http_status === 401 && error.response.data.status_code == "ERR9") {
          toast.error("Invalid Token");
          setTimeout(() => {
            navigate("/college/");
          }, 5000);

        }
        else if (error.response.data.http_status === 429 && error.response.data.status_code == "ERR33") {
          toast.error(error.response.data.message);
        }
        else if (error.response.data.http_status === 500 && error.response.data.status_code == "ERR5") {
          toast.error("No active exam found");
        }
        else {
          toast.error("Something went wrong");
        }
      }
    };

    fetchCaptcha();
    fetchExamData();
  }, []);


  const fetchCaptcha = async () => {
    try {
      const response = await http.get('Result/GenerateCaptcha');

      setCaptchaImage(response.data.cap_img);
      setFormData({ ...formData, ['captcha_id']: response.data.captcha_id });

    } catch (error) {
      toast.error("Failed to fetch captcha");
    }
  };

  const downloadPdf = async () => {

    setLoading(true);
    try {
      const response = await http.get('Result/singleResultpdf', {
        params: {
          examid: formData.examId,
          prn: formData.prn,
          captcha_in: formData.captchaInput,
          captcha_id: formData.captcha_id
        },
        responseType: 'blob',
      });

      if (response && response.data) {
        // Create a URL for the downloaded file
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;

        // Set the file name and download the PDF
        link.setAttribute('download', `${studentData.PRN}.pdf`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setLoading(false);
        return Promise.resolve('PDF generated successfully');
      }

    } catch (error) {
      setLoading(false);

      if (error.response.data.http_status === 401 && error.response.data.status_code == "ERR9") {
        toast.error("Invalid Token");
        setTimeout(() => {
          navigate("/college/");
        }, 5000);

      }
      else if (error.response.status === 422) {
        //console.log("ERROR==",error.response.message);
        //toast.error(error.response.message);
        toast.error('Invalid Captcha');

      }
      else {
        console.error('Error generating PDF:', error);
        toast.error('Error generating PDF');
      }

      //toast.error('Error generating PDF');
    }

  }

  return (
    <>
      <ToastContainer />

      {loading ? (

        <div className="container-fluid">
          <div className="row justify-content-center align-items-center">
            <div className="col-sm-12">
              <div className="card h-100">
                <div className="card-body d-flex justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
                  <div className="containeranimate">
                    <div className="dot"></div>
                    <div className="dot"></div>
                    <div className="dot"></div>
                    <div className="dot"></div>
                    <div className="dot"></div>
                    <div className="dot"></div>
                    <div className="dot"></div>
                    <div className="dot"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="my-page1">

          <div className="container-fluid bg-light py-5">

            <div
              className="d-flex flex-column align-items-center justify-content-center"
              style={{ gap: "1rem" }}
            >
              <img className="img-fluid mb-3" src={logo} alt="MGU Logo" style={{ maxWidth: '200px' }} />
            </div>
            <h3 className="card-title text-center mb-4  fw-bold">
              <span className="text-black txt-sz">  MGU UGP Examination Results</span>
            </h3>

            <div className="container" style={{ maxWidth: "1000px" }}>
              <form onSubmit={handleSubmit} className="card shadow-sm">
                <div className="card-body p-4">
                  <div className="col-12">
                    <div className="row">
                      <div className="col-md-8 col-12">
                        <label className="form-label fw-semibold">Select Examination</label>
                        <Select
                          maxMenuHeight={200}
                          menuPlacement="auto"
                          id="exam_id"
                          name="examId"
                          className="basic-select"
                          classNamePrefix="select"
                          placeholder="Choose your examination..."
                          onChange={(e) => setFormData({ ...formData, examId: e.value })}
                          options={getexamData.map(exam => ({
                            value: exam.examid,
                            label: exam.examtitle
                          }))
                          }
                          defaultValue={{ value: formData.examId, label: getexamData.find(exam => exam.examid === formData.examId)?.examtitle }}
                        />
                      </div>
                      <div className="col-md-4 col-12">
                        <label className="form-label fw-semibold">PRN</label>
                        <input
                          type="text"
                          className="form-control form-control-lg"
                          placeholder="Enter your PRN"
                          name="prn"
                          value={formData.prn}
                          onChange={handleInputChange}
                        />
                      </div>
                    </div>
                  </div>


                  <div className="col-12">
                    <div className="bg-light p-3 rounded">
                      <div className="row align-items-center">
                        <div className="col-md-4">
                          <img
                            src={`data:image/png;base64,${captchaImage}`}
                            alt="CAPTCHA"
                            className="img-fluid"
                            style={{ maxWidth: "500px", height: "50px" }}
                          />
                          <button className="btn btn-link p-0 text-decoration-none" type="button" onClick={() => fetchCaptcha()}>
                            <i className="bi bi-arrow-counterclockwise ms-2 text-primary"></i>
                          </button>
                        </div>

                        <div className="col-md-8">
                          <input
                            type="text"
                            className="form-control form-control-lg"
                            placeholder="Enter CAPTCHA code"
                            name="captchaInput"
                            value={formData.captchaInput}
                            onChange={handleInputChange}
                          />
                          {errorMessage && (
                            <div className="text-danger mt-2 small">{errorMessage}</div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Submit Button */}
                  <div className="col-12 mt-3">
                    <button type="submit" className="btn btn-primary btn-lg w-100">
                      Verify & Proceed
                    </button>
                  </div>

                </div>
              </form>
            </div>



            <div className='ex-table-container'
              style={{
                overflowX: "auto", // Enable horizontal scrolling
                maxWidth: "100%", // Ensure it respects parent width
              }}
            >



              {tableData && tableData.length > 0 ? (
                <>

                  <div className="col-12 mt-3 d-flex justify-content-center mb-3">
                    <button
                      type="button"
                      className="btn btn-primary btn-lg"
                      onClick={() => downloadPdf()}
                    >
                      Download PDF
                    </button>
                  </div>



                  {/* <div className="container py-4">
                    <div className="row justify-content-center">
                      <div className="col-md-8 col-lg-6">
                        <div className="card shadow-sm border-0">
                          <div className="card-body p-4">

                            <div className="text-center">
                              <h2 className="card-title h4 mb-3">{studentData.examtitle}</h2>
                              <h3 className="card-subtitle h6 text-muted mb-4">{studentData.college_name}</h3>
                            </div>

                            <div className="list-group list-group-flush">
                              <div className="list-group-item bg-light rounded mb-2">
                                <div className="d-flex justify-content-between align-items-center text-black">
                                  <span className="fw-semibold">PRN</span>
                                  <span>{studentData.PRN}</span>
                                </div>
                              </div>

                              <div className="list-group-item bg-light rounded mb-2">
                                <div className="d-flex justify-content-between align-items-center text-black">
                                  <span className="fw-semibold">Student Name</span>
                                  <span>{studentData.studentname}</span>
                                </div>
                              </div>

                              <div className="list-group-item bg-light rounded">
                                <div className="d-flex justify-content-between align-items-center text-black">
                                  <span className="fw-semibold">Programme</span>
                                  <span>{studentData.programme}</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div> */}

                  <table className="table ex-table1 m-b-30 table-striped" style={{ width: "100%", fontSize: "0.85rem" }}>
                    <thead>

                      <tr>
                        <th colSpan={24} style={{
                          textAlign: 'center',
                          padding: "12px",
                          backgroundColor: "#FFFFFF",
                          borderBottom: "2px solid #ddd"
                        }}>
                          PRN: {studentData.PRN} | Student Name: {studentData.studentname} | Programme: {studentData.programme} | College: {studentData.college_name}
                        </th>
                      </tr>

                      <tr>
                        <th rowSpan={2} style={{ width: '4%', verticalAlign: "middle" }} >Category</th>
                        <th rowSpan={2} style={{ width: '20%', verticalAlign: "middle", textAlign: 'center' }}>Course</th>
                        <th rowSpan={2} style={{ textAlign: 'center', verticalAlign: "middle" }} >Credits</th>
                        <th colSpan={7} style={{ textAlign: 'center', verticalAlign: "middle", backgroundColor: '#DF7886', color: 'white' }}>Theory</th>
                        <th colSpan={7} style={{ textAlign: 'center', verticalAlign: "middle", backgroundColor: '#C45966', color: 'white' }} >Practical</th>

                        <th rowSpan={2} style={{ verticalAlign: "middle", textAlign: 'center' }} >Total marks secured</th>
                        <th rowSpan={2} style={{ backgroundColor: 'rgb(196, 89, 102,0.2)', verticalAlign: "middle", textAlign: 'center' }}>Maximum marks</th>
                        <th rowSpan={2} style={{ textAlign: 'center', verticalAlign: "middle" }} >Grade</th>
                        <th rowSpan={2} style={{ textAlign: 'center', verticalAlign: "middle" }} >Grade Points</th>
                        <th rowSpan={2} style={{ textAlign: 'center', verticalAlign: "middle" }}>Acquired Credits</th>
                        <th rowSpan={2} style={{ textAlign: 'center', verticalAlign: "middle" }}>Credit Point</th>
                        <th rowSpan={2} style={{ textAlign: 'center', verticalAlign: "middle" }}>Overall Result</th>
                      </tr>
                      <tr>
                        <th style={{ textAlign: 'center', verticalAlign: "middle" }}>CCA</th>
                        <th style={{ backgroundColor: 'rgb(196, 89, 102,0.2)', textAlign: 'center', verticalAlign: "middle" }}>CCA<br /> Max</th>
                        <th style={{ textAlign: 'center', verticalAlign: "middle" }}>ESE</th>
                        <th style={{ backgroundColor: 'rgb(196, 89, 102,0.2)', textAlign: 'center', verticalAlign: "middle" }}>ESE Max</th>
                        <th style={{ textAlign: 'center', verticalAlign: "middle" }}>Theory Total</th>
                        <th style={{ backgroundColor: 'rgb(196, 89, 102,0.2)', textAlign: 'center', verticalAlign: "middle" }}>Theory Maximum</th>
                        <th style={{ textAlign: 'center', verticalAlign: "middle" }} >Theory Result</th>
                        <th style={{ textAlign: 'center', verticalAlign: "middle" }}>CCA</th>
                        <th style={{ backgroundColor: 'rgb(196, 89, 102,0.2)', textAlign: 'center', verticalAlign: "middle" }}>CCA Max</th>
                        <th style={{ textAlign: 'center', verticalAlign: "middle" }}>ESE</th>
                        <th style={{ backgroundColor: 'rgb(196, 89, 102,0.2)', textAlign: 'center', verticalAlign: "middle" }}>ESE Max</th>
                        <th style={{ textAlign: 'center', verticalAlign: "middle" }} >Practical Total</th>
                        <th style={{ backgroundColor: 'rgb(196, 89, 102,0.2)', textAlign: 'center', verticalAlign: "middle" }}>Practical Maximum</th>
                        <th style={{ textAlign: 'center', verticalAlign: "middle" }}>Practical Result</th>
                      </tr>

                    </thead>
                    <tbody>
                      {tableData.map((row, index) => (
                        <tr key={index} style={{ textAlign: 'center', verticalAlign: "middle" }}>
                          <td style={{ textAlign: 'center', verticalAlign: "middle" }}>{row.category}</td>
                          <td style={{ textAlign: 'center', verticalAlign: "middle" }}>{row.course}</td>
                          <td style={{ textAlign: 'center', verticalAlign: "middle" }}>{row.totalcredits}</td>
                          <td style={{ textAlign: 'center', verticalAlign: "middle" }}>{isMalpractice ? "-" : row.theory.cca}</td>
                          <td style={{ backgroundColor: "rgba(196, 89, 102, 0.2)", verticalAlign: "middle", textAlign: 'center' }}>{row.theory.ccaMax}</td>
                          <td style={{ textAlign: 'center', verticalAlign: "middle" }}>{isMalpractice ? "-" : row.theory.ese}</td>
                          <td style={{ backgroundColor: "rgba(196, 89, 102, 0.2)", verticalAlign: "middle", textAlign: 'center' }}>{row.theory.eseMax}</td>
                          <td style={{ textAlign: 'center', verticalAlign: "middle" }}>{isMalpractice ? "-" : row.theory.total}</td>
                          <td style={{ backgroundColor: "rgba(196, 89, 102, 0.2)", verticalAlign: "middle", textAlign: 'center' }}>{row.theory.max}</td>
                          <td style={{ textAlign: 'center', verticalAlign: "middle" }}>{isMalpractice ? "-" : row.theory.theory_result}</td>
                          <td style={{ textAlign: 'center', verticalAlign: "middle" }}>{isMalpractice ? "-" : row.practical.cca}</td>
                          <td style={{ backgroundColor: "rgba(196, 89, 102, 0.2)", verticalAlign: "middle", textAlign: 'center' }}>{row.practical.ccaMax}</td>
                          <td style={{ textAlign: 'center', verticalAlign: "middle" }}>{isMalpractice ? "-" : row.practical.ese}</td>
                          <td style={{ backgroundColor: "rgba(196, 89, 102, 0.2)", verticalAlign: "middle", textAlign: 'center' }}>{row.practical.eseMax}</td>
                          <td style={{ textAlign: 'center', verticalAlign: "middle" }}>{isMalpractice ? "-" : row.practical.total}</td>
                          <td style={{ backgroundColor: "rgba(196, 89, 102, 0.2)", verticalAlign: "middle", textAlign: 'center' }}>{row.practical.max}</td>
                          <td style={{ textAlign: 'center', verticalAlign: "middle" }}>{isMalpractice ? "-" : row.practical.practical_result}</td>
                          <td style={{ textAlign: 'center', verticalAlign: "middle" }}>{isMalpractice ? "-" : row.totalSecured}</td>
                          <td style={{ backgroundColor: "rgba(196, 89, 102, 0.2)", verticalAlign: "middle", textAlign: 'center' }}>{row.maxMarks}</td>
                          <td style={{ textAlign: 'center', verticalAlign: "middle" }}>{isMalpractice ? "-" : row.grade}</td>
                          {/* <td style={{ textAlign: 'center', verticalAlign: "middle" }}>{isMalpractice ? "-" : row.gradePoints}</td> */}

                          <td style={{ textAlign: 'center', verticalAlign: "middle" }}>
                            {isMalpractice ? "-" : parseInt(row.gradePoints, 10)}
                          </td>


                          <td style={{ textAlign: 'center', verticalAlign: "middle" }}>{isMalpractice ? "-" : row.acquiredCredits}</td>
                          <td style={{ textAlign: 'center', verticalAlign: "middle" }}>{isMalpractice ? "-" : row.creditPoint}</td>
                          <td style={{ verticalAlign: "middle", textAlign: 'center', color: row.overallResult === "Pass" ? "green" : "red", fontWeight: "bold" }}>
                            {row.overallResult}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>

                  <div className="txt-aln-jst m-10">
                    <p className="text-center">
                      <span className="text-danger st-res-not">
                        {/* <b>O-Outstanding, A+-Excellent, A-Very Good, B+-Good, B-Above Average, C-Average, P-Pass, F-Failure , Ab-Absent </b>*/}
                      </span>
                      <span className="text-danger st-res-not">
                        <b>{gradePoints}, Ab-Absent</b>
                      </span>
                    </p>
                    <p >
                      <span className="text-danger st-res-not">* The results presented on this webpage are provisional. If discrepancies are found during the verification of qualifying certificates provided by the student, the published results will be considered invalid.<br />
                        * The results available through the web are intended only to provide immediate information to the examinees. They are not a substitute for the original mark lists/ grade sheets issued to the candidates. Mahatma Gandhi University reserves the right to update the contents of the web pages without notice.                                               </span>
                    </p>
                  </div>







                </>
              ) : null
              }
            </div>
          </div>
        </div>
      )}

    </>



  );
};

export default Viewresult;
